// @mui
import { styled } from '@mui/material/styles';
import { Typography, Stack, Avatar, Rating, Button, Divider } from '@mui/material';
import React, { useState, useEffect, useMemo } from 'react';
import { useAuthContext } from '../../../auth/useAuthContext';
// auth
import RatingReportPopup from './ratingreportpopup';
import { fAgreementDate } from '../../../utils/formatTime';
import AppCache from '../../../services/appcache';

// ------------------------------------------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    // padding: theme.spacing(2, 2.5),
    padding: theme.spacing(0.1, 2.5),
    // borderRadius: Number(theme.shape.borderRadius) * 1.5,
    // backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

// -------------------------------------------------------------------------------------------------------

const FlashingTypography = styled(Typography)(
    ({ theme }) => ({
        animation: `flashAnimation 1s infinite`,
        '@keyframes flashAnimation': {
            '0%': {
                opacity: 1,
            },
            '50%': {
                opacity: 0,
            },
            '100%': {
                opacity: 1,
            },
        },
    })
);

export default function DealerNavAccount() {

    // Current logged in user
    const { user } = useAuthContext();
    const currentLoggedInUser = AppCache.GetCurrentLoggedInUser();
    // Rating
    const rating = AppCache.GetRating();
    const [openModalForReport, setopenModalForReport] = useState(false);
    // Agreement expiry
    const agreementExpiryDate = useMemo(() => new Date(AppCache.GetAgreementExpiryDate()), []);
    const today = useMemo(() => new Date(), []);
    const differenceMs = agreementExpiryDate - today;
    const differenceDays = Math.floor(differenceMs / (1000 * 60 * 60 * 24));
    const [isFlashing, setIsFlashing] = useState(false);
    const [color, setColor] = useState(null);

    useEffect(() => {
        if (differenceDays <= 90) {
            setIsFlashing(true);
            setColor('primary.light');
        }
        else if (differenceDays <= 150 && differenceDays > 90) {
            setIsFlashing(false);
            setColor('#FFBF00');
        }
        else {
            setIsFlashing(false);
            setColor('success.main');
        }
    }, [agreementExpiryDate, today, differenceDays])

    const handleOpenReport = () => {
        setopenModalForReport(true);
    }

    const handleCloseReport = () => {
        setopenModalForReport(false);
    }

    return (
        <StyledRoot>
            {/* <Stack direction='row' justifyContent='space-between' spacing={2} flexGrow={1} sx={{ mx: 4, mb: 1 }}>
                <Avatar src={currentLoggedInUser.ProfileImage} alt="photoURL" />    */}
            <Stack direction='column' justifyContent='space-between' flexGrow={1}>
                <Typography variant="subtitle2" sx={{ color: 'common.black' }}>
                    {currentLoggedInUser.UserFirstName} {currentLoggedInUser.UserLastName}
                </Typography>

                <Typography variant="caption" sx={{ color: 'common.black' }}>
                    {currentLoggedInUser.DistributorName}
                </Typography>

                {rating &&
                    <Stack direction='row' alignItems='center' justifyContent='space-between' sx={{ mt: 0.7 }}>
                        <Button onClick={handleOpenReport} sx={{ p: 0 }} style={{ display: "none" }}>
                            <Rating
                                name="half-rating-read"
                                //  defaultValue={rating}
                                value={rating}
                                precision={0.5}
                                size="small"
                                readOnly

                            />
                        </Button>

                        {/*  <Typography variant='caption' color='warning.main'>
                            {rating}
                        </Typography>   */}
                    </Stack>
                }

                {agreementExpiryDate &&
                    <>
                        <Stack direction='row' alignItems='flex-start' justifyContent='space-between'>
                            <Typography variant='subtitle2'>
                                Agreement Expiry
                            </Typography>
                            {!isFlashing ?
                                <Typography variant='subtitle2' color={color}>
                                    {fAgreementDate(agreementExpiryDate)}
                                </Typography>
                                :
                                <FlashingTypography variant='subtitle2' color={color}>
                                    {fAgreementDate(agreementExpiryDate)}
                                </FlashingTypography>
                            }
                        </Stack>
                        {isFlashing && differenceDays > 0 &&
                            <Stack direction='row' alignItems='center' justifyContent='center'>
                                <Typography variant='subtitle2' color='primary.light'>
                                    {differenceDays} Days to Expire
                                </Typography>
                            </Stack>
                        }
                    </>
                }
            </Stack>

            {openModalForReport && <RatingReportPopup confirm={handleCloseReport} />}
        </StyledRoot>
    );
}